import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";

/**
 * Landing page Stripe redirects to when the buyer cancels the season-pass
 * checkout. No side effects — the pending purchase row stays as-is on the
 * backend and the member can retry from the browse banner.
 */
const SeasonPassCancel = () => {
  const params = new URLSearchParams(useLocation().search);
  const seasonPassId = params.get("season_pass_id");

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-purple-50 flex items-center justify-center p-6">
      <div
        className="max-w-md w-full bg-white rounded-xl shadow-lg border border-slate-200 p-6 text-center"
        data-testid="season-pass-cancel-card"
      >
        <div className="rounded-full bg-slate-100 p-3 mx-auto w-fit">
          <XCircle className="h-8 w-8 text-slate-500" />
        </div>
        <h1 className="mt-3 text-lg font-semibold text-slate-900">
          Season pass purchase cancelled
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          No charge was made. You can retry from the Season Passes banner on your dashboard whenever
          you're ready.
        </p>
        {seasonPassId && (
          <p className="mt-1 text-[11px] text-slate-400">Pass: {seasonPassId.slice(-8)}</p>
        )}
        <Link to="/">
          <Button
            className="mt-4 w-full bg-purple-600 hover:bg-purple-700 text-white"
            data-testid="season-pass-cancel-back"
          >
            <ArrowLeft className="h-4 w-4 mr-1" /> Back to dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default SeasonPassCancel;
